import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import { Chip, TableCell, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextChip from './TextChip';
import { BACKUP_STATUS } from '../../../../constants';
import { sentenceCase } from '../../../../utils/utils';
import Text from '../../../elements/text/Text';

const StatusCell = ({ subject, status, schedules, error }) => {
  const { t } = useTranslation();

  const statusColor =
    status === BACKUP_STATUS.CREATED
      ? 'success'
      : status === BACKUP_STATUS.FAILED
        ? 'error'
        : 'warning';

  const statusIcon =
    status === BACKUP_STATUS.CREATED ? (
      <CheckCircleOutlineIcon fontSize="small" />
    ) : status === BACKUP_STATUS.FAILED ? (
      <ErrorOutlineIcon fontSize="small" />
    ) : (
      <QueryBuilderIcon fontSize="small" />
    );

  return (
    <TableCell>
      <Text text={subject} />
      {status && (
        <Tooltip placement="right" title={error || ''}>
          <Chip
            aria-label="status"
            color={statusColor}
            size="small"
            icon={statusIcon}
            label={
              <Text caption>{sentenceCase(status).replace(/_/g, ' ')}</Text>
            }
          />
        </Tooltip>
      )}
      {schedules && (
        <TextChip
          title={t('backup.saved', { ns: 'project' })}
          text={schedules}
        />
      )}
    </TableCell>
  );
};

StatusCell.propTypes = {
  subject: PropTypes.string.isRequired,
  status: PropTypes.string,
  schedules: PropTypes.number,
  error: PropTypes.string,
};

export default StatusCell;
